import React from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import image1 from "../assets/revolution.jpg";
import image2 from "../assets/abha.jpg";
import image3 from "../assets/image3.png";
import image4 from "../assets/image4.png";
import image5 from "../assets/smart.jpg";
import image6 from "../assets/image6.png";
import image201 from "../assets/image201.png";
import image202 from "../assets/image202.png";
import image203 from "../assets/image203.png";
import image204 from "../assets/image204.png";

const Blog = () => {
  const blogs = [
    {
      image: image203,
      alt: "CuttingDownPatientReportDeliveryTimewithAIBlog",
      to: "/cuttingdownpatientreportdeliverytimewithaiblog",
      text: "Learn more about Cutting Down Patient Report Delivery Time with AI",
    },
    {
      image: image2,
      alt: "InPatientOutPatientBlog",
      to: "/inpatientoutpatientblog",
      text: "The Future of AI in Indian Healthcare: ABHA and Beyond",
    },
    {
      image: image1,
      alt: "VoicePrescriptionBlog",
      to: "/voiceprescriptionblog",
      text: "How AI Improves Patient Care and Experience",
    },
    {
      image: image5,
      alt: "HospitalPharmacyIntegrationBlog",
      to: "/hospitalpharmacyintegrationblog",
      text: "AI in Healthcare: Transforming Hospitals with Smart Automation",
    },
    {
      image: image6,
      alt: "InventoryTrackingBlog",
      to: "/inventorytrackingblog",
      text: "Learn more about Inventory Management",
    },
    {
      image: image202,
      alt: "BestHMSforYourHospitalBlog",
      to: "/besthmsforyourhospitalblog",
      text: "Learn more about Best HMS for Your Hospital ",
    },
    {
      image: image4,
      alt: "DiagnosticLabIntegrationBlog",
      to: "/diagnosticlabintegrationblog",
      text: "Learn more about Diagnostic Lab Integration",
    },
    {
      image: image201,
      alt: "PredictiveAnalyticsBlog",
      to: "/predictiveanalyticsblog",
      text: " Learn more about Predictive Analytics ",
    },
    {
      image: image3,
      alt: "AdvancedAnalyticsCampaignBlog",
      to: "/advancedanalyticscampaignblog",
      text: "Learn more about Advanced Analytics Campaign",
    },
    // New Medicine Forecasting Blog
    {
      image: image204,
      alt: "MedicineForecastingBlog",
      to: "/medicineforecastingblog",
      text: "Medicine Forecasting: Smarter Pharmacy Planning with AI",
    },
  ];

  return (
    <div className="bg-[#d2e5e4] w-full py-16 px-4">
      <motion.h1
        className="text-3xl sm:text-4xl font-bold text-center mb-12 text-gray-800"
        initial={{ opacity: 0, y: 60 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
        viewport={{ once: true }}
      >
        Insights & Updates
      </motion.h1>

      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6 max-w-7xl mx-auto">
        {blogs.map((blog, index) => (
          <motion.div
            key={index}
            initial={{ opacity: 0, y: 80 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: index * 0.2 }}
            viewport={{ once: true }}
            className="bg-white rounded-xl shadow-md overflow-hidden flex flex-col items-center p-4 hover:shadow-lg transition-shadow duration-300"
          >
            <img
              src={blog.image}
              alt={blog.alt}
              className="w-full h-58 object-cover rounded-lg mb-4"
            />

            <Link
              to={blog.to}
              className="text-center text-blue-600 font-medium hover:underline"
            >
              {blog.text}
            </Link>
          </motion.div>
        ))}
      </div>
    </div>
  );
};

export default Blog;
